import styled from '@helpscout/hsds-react/components/styled'

export const ColorPickerUI = styled('div')`
  color: black;

  input {
    color: black;
  }
`
